import React, { useContext } from 'react';
import CategoryTable from './CategoryTable';
import { CommonContext, CategoryContext } from '../../context';
import { Box, Button, CardHeader, Paper } from '@mui/material';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import AddModal from './AddModal';
import FilterBar from './FilterBar';
import { DownloadOutlined } from '@mui/icons-material';

export default function CategoryScreenView() {
    const { openAlert } = useContext(CommonContext);
    const { isLoading, handleAddModal, onExport } = useContext(CategoryContext);
    return (
        <div className='main-screen'>
            {openAlert && <AlertMessage />}
            {isLoading && <Loader />}
            <AddModal />
            <Box className="component-header">
                <CardHeader title="Category" />
                <Box className="action-btns-group">
                    <Button variant="outlined" className="action-btn" endIcon={<DownloadOutlined />}
                        onClick={() => onExport()}
                    >
                        Export Category[s]
                    </Button>
                    <Button variant="outlined" className="action-btn" onClick={handleAddModal}>
                        Add Category
                    </Button>
                </Box>
            </Box>
            <Paper sx={{ boxShadow: 'none' }}>
                <FilterBar />
                <CategoryTable />
            </Paper>
        </div>
    );
}
